import { Injectable } from '@angular/core';
import {Resolve } from '@angular/router';
@Injectable()

export class FullMenuConceptResolver implements Resolve<any> {
    resolve() {
      return (window.innerWidth > 1367);
    }
}
